export const store = {
  state: {
    doneQ: false,
    doneU: false,
    doneB: false
  }
};
